import { ChangeDetectionStrategy, Component, Input, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Question } from 'src/app/models/question.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { map } from 'rxjs';
import { AnswersStore } from 'src/app/store/answers-store';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Answer } from 'src/app/models/Answer.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AutoResizeDirective } from 'src/app/directves/autoresize.directive';

@Component({
    selector: 'que-free-text-question-display',
    imports: [CommonModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        TranslateDirective, TranslatePipe,
        CommonModule,
        AutoResizeDirective],
    templateUrl: './free-text-question-display.component.html',
    styleUrls: ['./free-text-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FreeTextQuestionDisplayComponent implements OnInit {
  @Input()
  question?: Question;
  @Input()
  isSub: boolean = false;
  @Input() viewAnswer = false;
  myAnswer?: Answer;
  answer = new FormControl();
  #answerStore = inject(AnswersStore);

  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));

  ngOnInit(): void {
    this.answer.setValidators(this.question?.requierd ? [Validators.required] : null);
    this.isNotUser$.subscribe((isNotUser) => {
      if (isNotUser) {
        this.answer.disable();
      } else {
        this.answer.enable();
      }
    });

    this.answer.valueChanges.subscribe(
      ans => {
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, textAnswer: ans, isValid: this.answer.valid })
      });
    this.#answerStore.answers$.pipe(map(arr => arr.find(ans => ans.questionId == this.question?.id))).subscribe(x => {
      if (x) {
        this.myAnswer = x;
        this.answer.setValue(x.textAnswer, { emitEvent: false });
      }
    }).unsubscribe();
  }
}